import { useDestinationsInAddress } from '@/abilities/useDestinationsInAddress';
import { createDestinationRouteCondition } from '@/abilities/routeCondition';
import { useCompanyDashboardAccess } from '@/abilities/companyDashboard/useCompanyDashboardAccess';
import {
  isCompanyDashboardDestination,
  type CompanyDashboardDestinationKey,
} from '@/abilities/companyDashboard/vocabulary';

export const companyDashboardRoute = createDestinationRouteCondition(useCompanyDashboardAccess);

// From the page down to its tab; empty when no dashboard route declares the address.
export const useCompanyDashboardDestinationsInAddress = (): CompanyDashboardDestinationKey[] =>
  useDestinationsInAddress(isCompanyDashboardDestination);
